import {TrackingAction, TrackingActionType, TrackingFeature, TrackingFeatureLabels, TrackingFeatureStatus} from "../types";
import Tile from "./tile";

export class TrackingServiceCard {

    private global: OttoGlobal;

    constructor() {
        /*🤫*/
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            /*🤫*/
            /*🤫*/
            this.global.eventQBus = {
                emit: () => {
                    if (window.o_global.debug.status().activated) {
                        /*🤫*/
                        console.log("Tracking not available.");
                    }
                }
            }
        }

        /*🤫*/
        if (!window.o_util) {
            window.o_util = {
                /*🤫*/
                /*🤫*/
                misc: {
                    getPagecluster: () => {
                        if (window.o_global.debug.status().activated) {
                            /*🤫*/
                            console.log("Tracking not available.");
                        }
                        return null
                    }
                }
            }
        }
    }

    public sendSmallShoppromoInitialViewTrackingEvent(featureOrder: number, featureIndex: number, personalizationContext: string, tilesCount: number, tilesToTrack: Array<Tile>, masFeatureTrackingLabels: TrackingFeatureLabels): void {
        const trackingFeatures = [
            this.createSmallShoppromoFeature(featureOrder, featureIndex, tilesCount, personalizationContext, "loaded", masFeatureTrackingLabels),
            ...tilesToTrack.map((tile) => {
                tile.setIsTracked()
                return this.createSmallShoppromoTileFeature(tile, featureIndex, "loaded")
            })
        ];

        this.global.eventQBus.emit("tracking.bct.addFeaturesToPageImpression", trackingFeatures);
    }

    public sendSmallShoppromoSlideTrackingEvent(featureOrder: number, featureIndex: number, personalizationContext: string, tilesCount: number, tilesToTrack: Array<Tile>, movementType: TrackingActionType, masFeatureTrackingLabels: TrackingFeatureLabels) {
        const trackingFeatures: TrackingFeature[] = [
            this.createSmallShoppromoFeature(featureOrder, featureIndex, tilesCount, personalizationContext, "loaded", masFeatureTrackingLabels),
            ...tilesToTrack
                .filter((tile) => !tile.isTracked())
                .map((tile) => {
                    tile.setIsTracked()
                    return this.createSmallShoppromoTileFeature(tile, featureIndex, "loaded")
                })
        ];
        const trackingAction: TrackingAction = {name: movementType, features: trackingFeatures}

        this.global.eventQBus.emit('tracking.bct.submitAction', {}, trackingAction);
    }

    public sendSmallShoppromoClickTrackingEvent(featureOrder: number, featureIndex: number, personalizationContext: string, filledSlots: number, tile: Tile, masFeatureTrackingLabels: TrackingFeatureLabels) {
        const trackingFeatures = [
            this.createSmallShoppromoFeature(featureOrder, featureIndex, filledSlots, personalizationContext, "clicked", masFeatureTrackingLabels),
            this.createSmallShoppromoTileFeature(tile, featureIndex, "clicked")
        ];
        const trackingAction: TrackingAction = {
            name: "click",
            features: trackingFeatures
        }
        const wkTrackingData = {
            "wk.promo_AttributionFeature": `ShopPromotionSmall_${window.o_util.misc.getPagecluster()}`,
            "wk.promo_AttributionSource": tile.teslaModel
        }

        this.global.eventQBus.emit('tracking.bct.submitMoveAction', wkTrackingData, trackingAction);
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": "ShopPromotionSmall"});
    }

    private createSmallShoppromoFeature(featureOrder: number, featureIndex: number, filledSlots: number, personalizationContext: string, status: TrackingFeatureStatus, masFeatureTrackingLabels: TrackingFeatureLabels): TrackingFeature {
        const trackingLabels: TrackingFeatureLabels = {
            promo_FeatureNumber: [(featureIndex + 1).toString()],
            promo_FilledSlots: [(filledSlots).toString()],
            promo_Feature: ["true"],
            ...masFeatureTrackingLabels
        };
        personalizationContext ? trackingLabels.promo_Context = [personalizationContext] : null;

        return {
            id: 'ft3_spsnf' + featureIndex,
            name: "ShopPromotionSmall",
            position: featureOrder,
            status: status,
            labels: trackingLabels
        }
    }

    private createSmallShoppromoTileFeature(tile: Tile, featureIndex: number, status: TrackingFeatureStatus): TrackingFeature {
        const tileTrackingFeature: TrackingFeature = {
            id: "ft3_spsnf" + featureIndex + "_tile" + tile.position,
            parentId: "ft3_spsnf" + featureIndex,
            name: "ShopPromotionSmall-Tile",
            position: tile.position,
            status: status,
            labels: tile.featureTrackingLabels
        };
        tileTrackingFeature.variationId = tile.variationId ? tile.variationId : "none"
        return tileTrackingFeature
    }
}